import { useAppSelector } from '@/hooks/redux'
import {
  EReportType,
  ERunReportStep,
  ESearchType,
} from '@/pages/RunReport/types'
import { selectRunReport } from '@/store/api/RunReport/RunReport.selector'

const buildWizardPath = (
  reportType: string,
  isForCompanySearch: boolean,
  hasConsent: boolean,
  isPrefillForm: boolean,
): ERunReportStep[] => {
  if (isForCompanySearch) {
    return [
      ERunReportStep.CompanyForm,
      ERunReportStep.BehaviorFlags,
      ERunReportStep.Submit,
    ]
  }

  if (hasConsent) {
    return [
      ERunReportStep.ConsentRequired,
      ERunReportStep.SubjectForm,
      ERunReportStep.AddExtraDetails,
      ERunReportStep.BehaviorFlags,
      ERunReportStep.Submit,
    ]
  }

  if (reportType === EReportType.AiReport && !isPrefillForm) {
    return [
      ERunReportStep.RefineSearch,
      ERunReportStep.AddExtraDetails,
      ERunReportStep.BehaviorFlags,
      ERunReportStep.Submit,
    ]
  }

  return [
    ERunReportStep.SubjectForm,
    ERunReportStep.AddExtraDetails,
    ERunReportStep.BehaviorFlags,
    ERunReportStep.Submit,
  ]
}

export const useRunReportWizardStep = (
  currentStep: ERunReportStep,
): { current: number; total: number } => {
  const slice = useAppSelector(selectRunReport)
  const path = buildWizardPath(
    slice.selectSearchType.reportType,
    slice.selectSearchType.searchType === ESearchType.Company,
    slice.useCases.consentSwitchValue,
    slice.isPrefillForm,
  )
  const index = path.indexOf(currentStep)
  return {
    current: index === -1 ? 1 : index + 1,
    total: path.length,
  }
}
